import React, { useEffect, useRef, useState } from "react";
import {
  AccordionContent,
  AccordionItem,
} from "../../components-shadcn/accordion";
import { Checkbox } from "../../components-shadcn/checkbox";
import CustomInput from "../../components/CustomInput";
import { RadioGroup } from "../../components-shadcn/radio-group";
import { Label } from "../../components-shadcn/label";
import { ReactComponent as RadioButtomIcon } from '../../assets/radiobutton.svg'
import { ReactComponent as RadioButtomIconDisable } from '../../assets/radiobuttom_disable.svg'
import ButtonSave from "../../../src/components/ButtomSave";
import CustomAccordionTrigger from "../../../src/components/CustomAccordionTrigger";
import { isMobile } from "react-device-detect";
import axios from "axios";
import { toast } from "sonner";
import { useStore } from "../../lib/store";
import { AmplitudeLog } from "../../lib/amplitude";

interface Props {
  openItem: string;
  contato_seed: any;
  empresa_seed: any;
  negocio_seed: any;
}
const ContractorInformation: React.FC<Props> = ({ openItem, contato_seed, empresa_seed, negocio_seed }) => {

  const [can_submit, set_can_submit] = useState(false);
  const [loading, set_loading] = useState(false);
  const { id_pedido } = useStore();
  const { id_negocio } = useStore();

  const { set_sync_checkout } = useStore();

  const [even_billing, set_even_billing] = useState(negocio_seed.email_financeiro === "" ? "Sim" : "Não");
  const [is_business, set_is_business] = useState(empresa_seed.id && empresa_seed.cnpj.length > 11 ? true : false);

  //cnpj
  const [cnpjValue, setCnpjValue] = useState(empresa_seed.cnpj || "");
  const [errorCnpjValue, setErrorSetCnpjValue] = useState("");

  //razao social
  const [razaoValue, setRazaoSocialValue] = useState(empresa_seed.razao_social || "");
  const [errorRazaoValue, seterrorRazaoValue] = useState("");

  //Nome
  const [nameValue, setnameValue] = useState(contato_seed.nome || "");
  const [errornameValue, setErrorNameValue] = useState("");

  //CPF
  const [cardCPF, setCardCPF] = useState(contato_seed.cpf || "");
  const [errorCardCPF, setErrorCardCPF] = useState("");

  //email
  const [emailValue, setEmailValue] = useState(contato_seed.email || "");
  const [errorEmailValue, setErrorEmailValue] = useState("");

  //telefone
  const [cellPhoneValue, setCellPhoneValue] = useState(contato_seed.telefone || "");
  const [errorCellPhoneValue, setErrorCellPhoneValue] = useState("");

  //email para cobrança
  const [emailChargeValue, setEmailChargeValue] = useState(negocio_seed.email_financeiro || "");
  const [errorEmailChargeValue, setErrorEmailChargeValue] = useState("");

  //telefone para cobrança
  const [cellPhoneChargeValue, setCellPhoneChargeValue] = useState(negocio_seed.telefone_financeiro || "");
  const [errorCellPhoneChargeValue, setErrorCellPhoneChargeValue] = useState("");


  function VerifyBlankFields() {
    if (
      nameValue === "" ||
      cardCPF === "" ||
      emailValue === "" ||
      cellPhoneValue === ""
    ) {
      return true;
    }
    if (even_billing === "Não" && (emailChargeValue === "" || cellPhoneChargeValue === "")) {
      return true;
    }
    if (is_business && (cnpjValue === "" || razaoValue === "")) {
      return true;
    }
    return false;
  }

  function VerifyErros() {
    if (
      errornameValue !== "" ||
      errorCardCPF !== "" ||
      errorEmailValue !== "" ||
      errorCellPhoneValue !== ""
    ) {
      return true;
    }
    if (even_billing === "Não" && (errorEmailChargeValue !== "" || errorCellPhoneChargeValue !== "")) {
      return true;
    }
    if (is_business && (errorCnpjValue !== "" || errorRazaoValue !== "")) {
      return true;
    }
    return false;
  }

  const create_enterprise_hub = async () => {
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/create_enterprise_hub",
        {
          "razao_social": is_business ? razaoValue : nameValue,
          "cnpj": is_business ? cnpjValue : cardCPF,
          "id_empresa": empresa_seed.id ? empresa_seed.id : "",
          "id_negocio": id_negocio,
          "id_pedido": id_pedido
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_loading(false);
        return true;
      } else {
        toast(resposta.data.status_code + ": " + resposta.data.msg, {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
        set_loading(false);
        return false;
      }
    } catch (erro: any) {
      toast("Erro ao cadastrar empresa: Exception Error", {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      set_loading(false);
      return false;
    }
  };

  const create_contact_hub = async () => {
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/create_update_contact_hub",
        {
          "nome": nameValue,
          "cpf": cardCPF,
          "email": emailValue,
          "telefone": "+55" + cellPhoneValue,
          "id_negocio": id_negocio,
          "id_pedido": id_pedido,
          "id_contato": contato_seed.id
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_loading(false);
        return true;
      } else {
        toast(resposta.data.status_code + ": " + resposta.data.msg, {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
        set_loading(false);
        return false;
      }
    } catch (erro: any) {
      toast("Erro ao cadastrar empresa: Exception Error", {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      set_loading(false);
      return false;
    }
  };

  const update_deal_hub = async () => {
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/update_deal_hub",
        {
          "id_negocio": id_negocio,
          "id_pedido": id_pedido,
          "nome": nameValue,
          "cpf_cnpj": is_business ? cnpjValue : cardCPF,
          "email_financeiro": even_billing === "Sim" ? emailValue : emailChargeValue,
          "telefone_financeiro": even_billing === "Sim" ? "+55" + cellPhoneValue : "+55" + cellPhoneChargeValue
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_loading(false);
        return true;
      } else {
        toast(resposta.data.status_code + ": " + resposta.data.msg, {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
        set_loading(false);
        return false;
      }
    } catch (erro: any) {
      toast("Erro ao cadastrar empresa: Exception Error", {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      set_loading(false);
      return false;
    }
  };

  async function handleRequests() {
    if (VerifyBlankFields() === false && VerifyErros() === false) {
      AmplitudeLog("Checkout_Etapa_Concluida", {
        nome_etapa: "informacoes_contratante",
        tipo_contratante: is_business ? "CNPJ" : "CPF",
      });

      const condA = true;
      const condB = true;
      const condD = true;

      // Array dinâmico de funções a serem executadas
      const tasks: (() => Promise<boolean>)[] = [];

      if (condA) tasks.push(() => create_enterprise_hub());
      if (condB) tasks.push(() => create_contact_hub());
      if (condD) tasks.push(() => update_deal_hub());

      if (tasks.length === 0) return;

      // Execução sequencial
      for (const task of tasks) {
        try {
          const success = await task();
          if (success !== true) {
            console.error("Uma das requisições falhou.");
            return; // Interrompe se alguma falhar
          }
        } catch (err) {
          console.error("Erro durante uma requisição:", err);
          return;
        }
      }

      // Se chegou até aqui, todas tiveram sucesso
      console.log("Todas as requisições foram bem-sucedidas!");
      set_sync_checkout(true);
    } else {
      console.log("Tem erros ou campos em branco");
    }
  }

  useEffect(() => {
    if (VerifyBlankFields() === false && VerifyErros() === false) {
      set_can_submit(true);
    } else {
      set_can_submit(false);
    }
  },
    [
      cnpjValue,
      errorCnpjValue,
      razaoValue,
      errorCnpjValue,
      nameValue,
      errornameValue,
      cardCPF,
      errorCardCPF,
      emailValue,
      errorEmailValue,
      cellPhoneValue,
      errorCellPhoneValue,
      errorEmailChargeValue,
      errorEmailChargeValue,
      cellPhoneChargeValue,
      errorCellPhoneChargeValue,
      even_billing,
      is_business
    ]
  )




  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <AccordionItem value="2">
      <CustomAccordionTrigger value="2" openItem={openItem} number={2} title="Informações do contratante" />
      <AccordionContent>
        <p>Deseja nos contratar com CNPJ?</p>
        <div className="flex flex-row mt-[1.3rem] items-center cursor-pointer" onClick={() => { !empresa_seed.id ? set_is_business(is_business ? false : true) : console.log("") }}>
          <Checkbox
            id=""
            onClick={() => { !empresa_seed.cnpj ? set_is_business(is_business ? false : true) : console.log("") }}
            checked={is_business}
            className={`${is_business ? 'border-green-dark bg-green-dark text-white-primary' : 'border-blue-primary border-[2px]'}`}
          />
          <p className="font-[500] ml-[0.5rem]">Sim, estou contratando como empresa.</p>
        </div>
        {is_business &&
          <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem]'} gap-y-[1.2rem] mt-[1.2rem]`}>
            <CustomInput icon="none" placeholder="Digite" title="CNPJ" type="cnpj"
              value={cnpjValue}
              onChange={setCnpjValue}
              error={errorCnpjValue}
              onError={(e) => {
                setErrorSetCnpjValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "CNPJ", mensagem_erro: e });
              }}
              required
            />
            <CustomInput icon="none" placeholder="Digite" title="Razão social" type="generic"
              value={razaoValue}
              onChange={setRazaoSocialValue}
              error={errorRazaoValue}
              onError={(e) => {
                seterrorRazaoValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Razão social", mensagem_erro: e });
              }}
              required
            />
          </div>
        }
        <p className="mt-[1.3rem]">Informe os dados do responsável pelo contrato.</p>
        <div className="flex flex-col gap-y-[1.2rem] mt-[1.2rem]">
          <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem]'} gap-y-[1.2rem]`}>
            <CustomInput icon="none" placeholder="Digite" title="Nome completo" type="card_name"
              value={nameValue}
              onChange={setnameValue}
              error={errornameValue}
              onError={(e) => {
                setErrorNameValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Nome completo", mensagem_erro: e });
              }}
              required
              ref={inputRef}
            />
            <CustomInput
              icon="cpf"
              title="CPF do titular"
              placeholder="000.000.000-00"
              type="card_cpf"
              value={cardCPF}
              onChange={setCardCPF}
              error={errorCardCPF}
              onError={(e) => {
                setErrorCardCPF(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "CPF do titular", mensagem_erro: e });
              }}
              required
            />
          </div>
          <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem]'} gap-y-[1.2rem]`}>
            <CustomInput
              icon="email"
              title="E-mail"
              placeholder="Digite"
              type="email"
              value={emailValue}
              onChange={setEmailValue}
              error={errorEmailValue}
              onError={(e) => {
                setErrorEmailValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "E-mail", mensagem_erro: e });
              }}
              required
            />
            <CustomInput
              icon="cellphone"
              title="Telefone celular"
              placeholder="Digite"
              type="cellphone"
              value={cellPhoneValue}
              onChange={setCellPhoneValue}
              error={errorCellPhoneValue}
              onError={(e) => {
                setErrorCellPhoneValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Telefone celular", mensagem_erro: e });
              }}
              required
            />
          </div>
        </div>

        <p className="mt-[1.3rem]">Os contatos são os mesmos utilizados para cobranças?</p>
        <RadioGroup defaultValue="option-one" className="mt-[1rem]" >
          <div className="flex items-center space-x-2" onClick={() => { set_even_billing("Sim"); AmplitudeLog("Checkout_Interacao", { tipo_interacao: "alternar_contato_cobranca", valor_selecionado: "Sim" }) }}>
            {
              even_billing === "Sim" ?
                <RadioButtomIcon /> :
                <RadioButtomIconDisable />
            }
            <Label htmlFor="option-one">Sim</Label>
          </div>
          <div className="flex items-center space-x-2" onClick={() => { set_even_billing("Não"); AmplitudeLog("Checkout_Interacao", { tipo_interacao: "alternar_contato_cobranca", valor_selecionado: "Não" }) }}>
            {
              even_billing === "Não" ?
                <RadioButtomIcon /> :
                <RadioButtomIconDisable />
            }
            <Label htmlFor="option-two">Não</Label>
          </div>
        </RadioGroup>
        {even_billing === "Não" &&
          <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem]'} mt-[1rem] gap-y-[1.2rem]`}>
            <CustomInput
              icon="email"
              title="E-mail para cobranças"
              placeholder="Digite"
              type="email"
              value={emailChargeValue}
              onChange={setEmailChargeValue}
              error={errorEmailChargeValue}
              onError={(e) => {
                setErrorEmailChargeValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "E-mail para cobranças", mensagem_erro: e });
              }}
              required
            />
            <CustomInput
              icon="cellphone"
              title="Telefone para cobranças"
              placeholder="Digite"
              type="cellphone"
              value={cellPhoneChargeValue}
              onChange={setCellPhoneChargeValue}
              error={errorCellPhoneChargeValue}
              onError={(e) => {
                setErrorCellPhoneChargeValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Telefone para cobranças", mensagem_erro: e });
              }}
              required
            />
          </div>
        }
        <p className="mt-[2rem] text-red-primary font-[600]">* Indica um campo obrigatório</p>
        <ButtonSave
          className="mt-[1.6rem]"
          icon="none"
          theme={`${!can_submit ? 'lightgreen' : 'darkgreen'}`}
          onClick={() => { handleRequests() }}
          loading={loading}
        >
          Salvar e continuar
        </ButtonSave>
      </AccordionContent>
    </AccordionItem>
  );
};

export default ContractorInformation;
